import React from 'react';

// ---- Helpers ----
const StatusPill = ({ status }) => {
	const isSolved = status === 'SOLVED';
	const cls = isSolved ? 'bg-lightGreen text-textGreen' : 'bg-lightOrange text-textOrange';
	return (
        <span className={`px-2.5 py-1.5 inline-flex text-[11px] leading-5 font-semibold rounded-full ${cls}`}>
			{status}
		</span>
	);
};

const Actions = ({ onViewDetailsClick }) => (
    <div className="text-dark-blue text-18 leading-24 underline">
        <span className='cursor-pointer'
        onClick={onViewDetailsClick}>
            View Details</span>
        
	</div>
);

const UserQueriesTable = ({ userQueries, onViewDetails }) => {
	const styles = {
        tableDiv: 'bg-white rounded-lg overflow-auto mb-10',
        topTableHead: 'px-3.5 py-3.5 text-base leading-100 font-medium text-gray text-left',
        tableData: 'px-3.5 py-3.5 text-base font-medium text-dark-blue leading-100 text-left'
	};

	return (
		<div className={styles.tableDiv}>
			<div className="w-full">
                <table className="min-w-[680px] xl:min-w-full">
					<thead className="bg-[#F2F3F7]">
						<tr>
							<th scope="col" className={styles.topTableHead}>
								QUERY ID
							</th>
							<th scope="col" className={styles.topTableHead}>
								EMAIL
							</th>
							<th scope="col" className={styles.topTableHead}>
								MESSAGE
							</th>
							<th scope="col" className={styles.topTableHead}>
								STATUS
							</th>
							<th scope="col" className={styles.topTableHead}>
								ACTIONS
							</th>
						</tr>
					</thead>

					<tbody className="bg-white">
						{userQueries.map((u) => (
							<tr key={u.query_id}>
								<td className={styles.tableData}>{u.query_id}</td>
								<td className={styles.tableData}>{u.email}</td>
								<td className={`${styles.tableData} max-w-[250px] truncate whitespace-nowrap overflow-hidden`}>
									{u.message}
								</td>

                            <td className="px-4 py-3.5 text-base">
									<StatusPill status={u.status} />
								</td>
                            <td className="px-4 py-3.5">
									<Actions
										onViewDetailsClick={() => onViewDetails(u)}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default UserQueriesTable;
